module.exports = __webpack_public_path__ + "img/voyagelanding_large.aa7c3e65.png";